import { Link } from 'react-router-dom';
import { DollarSign, Users, FileText, CreditCard, Calculator, Settings } from 'lucide-react';

export default function PayrollOverview() {
  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-3xl font-bold tracking-tight">Payroll Management</h1>
        <p className="text-sm text-neutral-600">Comprehensive payroll and salary management system</p>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <Link
          to="/payroll/setup/structures"
          className="bg-white p-6 rounded-lg border hover:shadow-md transition-shadow"
        >
          <div className="flex items-center">
            <Settings className="w-8 h-8 text-blue-600" />
            <div className="ml-4">
              <h3 className="text-lg font-medium text-gray-900">Pay Structures</h3>
              <p className="text-sm text-gray-500">Set up salary structures for staff</p>
            </div>
          </div>
        </Link>

        <Link
          to="/payroll/runs"
          className="bg-white p-6 rounded-lg border hover:shadow-md transition-shadow"
        >
          <div className="flex items-center">
            <Calculator className="w-8 h-8 text-green-600" />
            <div className="ml-4">
              <h3 className="text-lg font-medium text-gray-900">Payroll Runs</h3>
              <p className="text-sm text-gray-500">Create and manage payroll processing</p>
            </div>
          </div>
        </Link>

        <Link
          to="/payroll/slips"
          className="bg-white p-6 rounded-lg border hover:shadow-md transition-shadow"
        >
          <div className="flex items-center">
            <FileText className="w-8 h-8 text-purple-600" />
            <div className="ml-4">
              <h3 className="text-lg font-medium text-gray-900">Payslips</h3>
              <p className="text-sm text-gray-500">View and generate payslips</p>
            </div>
          </div>
        </Link>

        <Link
          to="/payroll/payments"
          className="bg-white p-6 rounded-lg border hover:shadow-md transition-shadow"
        >
          <div className="flex items-center">
            <CreditCard className="w-8 h-8 text-orange-600" />
            <div className="ml-4">
              <h3 className="text-lg font-medium text-gray-900">Payments</h3>
              <p className="text-sm text-gray-500">Record and track salary payments</p>
            </div>
          </div>
        </Link>

        <div className="bg-white p-6 rounded-lg border">
          <div className="flex items-center">
            <Users className="w-8 h-8 text-indigo-600" />
            <div className="ml-4">
              <h3 className="text-lg font-medium text-gray-900">Staff Overview</h3>
              <p className="text-sm text-gray-500">Quick stats and summaries</p>
            </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-lg border">
          <div className="flex items-center">
            <DollarSign className="w-8 h-8 text-emerald-600" />
            <div className="ml-4">
              <h3 className="text-lg font-medium text-gray-900">Monthly Summary</h3>
              <p className="text-sm text-gray-500">Current month payroll totals</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
